import React from 'react';
import PropTypes from 'prop-types';
import {withResizeDetector} from 'react-resize-detector';
/* Components */
import ModalDefault from '../../../common/modal/modal-default';
import BulletinForm from './bulletin-form';
/* Styles */
import './bulletin.scss';
import WidgetHeader from '../widget-header/WidgetHeader';

class Bulletin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSettingsModalShown: false,
      data: {...this.props.data},
      temporaryEditorData: {...this.props.data},
    };

    this.joditEditorRef = React.createRef();
  }

  toggleSettingsModal = (e) => {
    e.stopPropagation();
    this.setState({
      isSettingsModalShown: !this.state.isSettingsModalShown,
    });
  };

  createMarkup = () => {
    return {__html: this.props.data.config.data};
  };

  handleSave = (data) => {
    const content = this.joditEditorRef.current.value;
    this.setState(
      {
        isSettingsModalShown: false,
        data: {
          ...this.state.temporaryEditorData,
          config: {
            ...this.state.temporaryEditorData.config,
            data: content,
          },
        },
      },
      () => {
        this.props.onUpdate({...this.state.data, title: data.title});
      }
    );
  };

  render() {
    return (
      <>
        <div className="glu-dashboard-card glu-content glu-display-widget">
          <WidgetHeader
            isEditAllowed={this.props.isEditAllowed}
            title={this.props.data.title}
            showWidgetInfo={this.props.showWidgetInfo(this.props.data)}
            openConfiguration={this.toggleSettingsModal}
            onRemove={this.props.onRemove(this.props.data)}
            onClone={this.props.onClone(this.props.data)}
          />
          <div className="glu-content__body">
            <div className="glu-content__section glu-content__separator glu-content__separator--inner">
              {/* eslint-disable-next-line react/no-danger */}
              <div dangerouslySetInnerHTML={this.createMarkup()} />
            </div>
          </div>
        </div>
        {this.state.isSettingsModalShown && (
          <ModalDefault isOpen={this.state.isSettingsModalShown}>
            <div className="glu-modal-content">
              <div className="glu-modal__header">
                <div className="glu-modal__title glu-flex-grow">{this.props.data.title}</div>
                <div className="glu-flex-shrink">
                  <button
                    aria-label="close"
                    type="button"
                    className="glu-btn-link g-icon g-icon-close"
                    onClick={this.toggleSettingsModal}
                  />
                </div>
              </div>
              <BulletinForm
                initialValues={this.state.data}
                onFormSubmit={this.handleSave}
                onCancel={this.toggleSettingsModal}
                ref={this.joditEditorRef}
              />
            </div>
          </ModalDefault>
        )}
      </>
    );
  }
}

Bulletin.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditAllowed: PropTypes.bool,
  onRemove: PropTypes.func,
  onUpdate: PropTypes.func,
  showWidgetInfo: PropTypes.func,
  onClone: PropTypes.func,
};

Bulletin.defaultProps = {
  isEditAllowed: false,
  onRemove: undefined,
  onUpdate: undefined,
  showWidgetInfo: undefined,
  onClone: undefined,
};

export default withResizeDetector(Bulletin);
